<div class="wrapper flex flex-col justify-between">
  <div class="heading text-type-2 mb-[20px]">
    {{ isEdit ? (data?.editItem?.item_number || 'Edit Item') : 'New punch item' }}
  </div>
  @if (isEdit && data?.editItem?.created_at) {
    <div class="created-meta text-type-14 text-[#60698B] -mt-[12px] mb-[20px]">
      Created
      @if (data.editItem.createdBy) {
        by {{ ((data.editItem.createdBy.first_name || '') + ' ' + (data.editItem.createdBy.last_name || '')).trim() || data.editItem.createdBy.email }}
      }
      on {{ data.editItem.created_at | date:'MMM d, y' }}
    </div>
  }

  <div class="details flex-1">
    <!-- W74: the list field sits below Title and Description; a new item defaults to the last-used open list -->
    <ng-template #punchList>
      <app-dropdown
        [options]="punchlistOptions"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="punchlist_id"
        label="punch list"
        hint="The list this item belongs to"
        data-testid="punch-item-list"
      />
    </ng-template>
    @if (!fields || (!fieldByName.title && !fieldByName.description)) {
      <ng-container *ngTemplateOutlet="punchList" />
    }
    @if (!fields) {
      <div class="text-type-14 text-[#60698B] py-[12px] mb-[20px]">Loading…</div>
    } @else {
      @for (field of fields; track field.name) {
        @switch (field.name) {
          @case ('title') {
            <app-text-input
              [label]="field.label || 'title'"
              [parentFormGroup]="form"
              class="w-full mb-[20px]"
              controlName="title"
              [maxLength]="500"
            />
            @if (!fieldByName.description) {
              <ng-container *ngTemplateOutlet="punchList" />
            }
          }
          @case ('description') {
            <app-text-area
              [label]="field.label || 'description'"
              [parentFormGroup]="form"
              class="w-full mb-[20px]"
              controlName="description"
            />
            <ng-container *ngTemplateOutlet="punchList" />
          }
          @case ('site_id') {
            <app-dropdown
              [enableSearch]="true"
              [label]="field.label || 'site'"
              [options]="sitesList"
              [parentFormGroup]="form"
              class="w-full mb-[20px]"
              controlName="site_id"
            />
          }
          @case ('bid_items') {
            <app-dropdown
              [enableDetailedOptionView]="true"
              [enableMultiple]="true"
              [enableSearch]="true"
              [label]="field.label || 'Bid Item'"
              [options]="bidItemOptions"
              [parentFormGroup]="form"
              [selectionString]="form.controls['bidItem']?.value?.length > 1 ? 'Bid Items' : 'Bid Item'"
              [showCount]="true"
              class="w-full mb-[20px]"
              controlName="bidItem"
              placeholder="Search"
            />
            <div class="selected-bid-item-list flex flex-col justify-center mb-[20px]">
              @if (selectedBidItemIds.length) {
                @for (bidItem of selectedBidItemIds; track bidItem?.id) {
                  <div class="bid-item-id-details-container mb-[10px]">
                    <div class="bid-item-id-details text-type-11">
                      <div class="each-item flex justify-start items-center gap-[16px]">
                        <div class="left flex justify-start items-center">
                          <div class="icon-wrapper">
                            <mat-icon svgIcon="daily-report-page-menu-bid-item" />
                          </div>
                        </div>
                        <div class="right flex flex-col justify-center items-start">
                          <div class="bid-item-heading text-type-6">Bid item {{ bidItem?.item }}</div>
                          <div class="h-[1px]">&nbsp;</div>
                          <div class="description text-type-14">{{ bidItem?.description }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              } @else {
                <div class="activity-id-name-container">
                  <div class="activity-id-name text-type-11">
                    No bid items selected
                  </div>
                </div>
              }
            </div>
          }
          @case ('category') {
            <!-- mat-select cannot switch between single and multiple once
                 created, hence one control per mode. -->
            @if (field.multiple) {
              <app-dropdown
                [enableMultiple]="true"
                [hint]="pickListHints.category"
                [label]="field.label || 'category'"
                [loading]="pickListLoading.category && !pickListOptions.category.length"
                [options]="pickListOptions.category"
                [parentFormGroup]="form"
                class="w-full mb-[20px]"
                controlName="category"
              />
            } @else {
              <app-dropdown
                [hint]="pickListHints.category"
                [label]="field.label || 'category'"
                [loading]="pickListLoading.category && !pickListOptions.category.length"
                [options]="pickListOptions.category"
                [parentFormGroup]="form"
                class="w-full mb-[20px]"
                controlName="category"
              />
            }
          }
          @case ('type') {
            @if (field.multiple) {
              <app-dropdown
                [enableMultiple]="true"
                [hint]="pickListHints.type"
                [label]="field.label || 'type'"
                [loading]="pickListLoading.type && !pickListOptions.type.length"
                [options]="pickListOptions.type"
                [parentFormGroup]="form"
                class="w-full mb-[20px]"
                controlName="type"
              />
            } @else {
              <app-dropdown
                [hint]="pickListHints.type"
                [label]="field.label || 'type'"
                [loading]="pickListLoading.type && !pickListOptions.type.length"
                [options]="pickListOptions.type"
                [parentFormGroup]="form"
                class="w-full mb-[20px]"
                controlName="type"
              />
            }
          }
          @case ('severity') {
            <app-dropdown
              [hint]="pickListHints.severity"
              [label]="field.label || 'severity'"
              [loading]="pickListLoading.severity && !pickListOptions.severity.length"
              [options]="pickListOptions.severity"
              [parentFormGroup]="form"
              class="w-full mb-[20px]"
              controlName="severity"
            />
          }
          @case ('need_by_date') {
            <app-date-picker
              [label]="field.label || 'need by date'"
              [parentFormGroup]="form"
              class="w-full mb-[20px]"
              controlName="need_by_date"
            />
          }
          @case ('location_description') {
            <app-text-input
              [label]="field.label || 'location'"
              [parentFormGroup]="form"
              class="w-full mb-[20px]"
              controlName="location_description"
            />
            <ng-container *ngTemplateOutlet="mapLocation" />
          }
          @case ('proposed_solution') {
            <app-text-area
              [label]="field.label || 'proposed solution'"
              [parentFormGroup]="form"
              class="w-full mb-[20px]"
              controlName="proposed_solution"
            />
          }
        }
      }
    }

    <!-- The pinned map location is not one of the configurable fields. It sits
         under the location text when the project shows that field, and after
         the fields when it does not. -->
    @if (!fieldByName.location_description) {
      <ng-container *ngTemplateOutlet="mapLocation" />
    }

    @if (linkedIssues.length) {
      <div class="issues-section mb-[20px]">
        <div class="issues-section-header flex items-center gap-[8px] mb-[12px]">
          <span class="section-label">Linked Issues</span>
          <span class="count-badge">{{ linkedIssues.length }}</span>
        </div>
        @for (issue of linkedIssues; track issue.id) {
          <div class="issue-item linked flex items-start gap-[12px] mb-[8px]">
            <div class="issue-info flex-1">
              <div class="issue-title text-type-11">{{ issue.title }}</div>
              <div class="issue-meta flex items-center gap-[8px] mt-[4px]">
                <span class="issue-type-badge">{{ issue.type || 'Issue' }}</span>
                <span class="issue-status-badge">{{ issueStatusText(issue.status) }}</span>
                <span class="issue-creator text-[#60698B]">{{ issue.created_by_first_name }} {{ issue.created_by_last_name }}</span>
              </div>
            </div>
            <button class="unlink-button" (click)="unlinkIssue(issue)" aria-label="Unlink issue">
              <mat-icon class="unlink-icon">link_off</mat-icon>
            </button>
          </div>
        }
      </div>
    }

    @if ((latitude !== null && longitude !== null) || form.get('site_id')?.value) {
      <div class="issues-section mb-[20px]">
        <div class="issues-section-header flex items-center gap-[8px] mb-[12px]">
          <span class="section-label">Nearby Issues</span>
          @if (nearbyIssues.length) {
            <span class="count-badge">{{ nearbyIssues.length }}</span>
          }
        </div>
        @if (nearbyIssuesLoading) {
          <div class="text-type-14 text-[#60698B] py-[12px]">Loading nearby issues...</div>
        } @else if (nearbyIssues.length === 0) {
          <div class="text-type-14 text-[#60698B] py-[12px]">No issues found nearby.</div>
        } @else {
          @for (issue of nearbyIssues; track issue.id) {
            <div class="issue-item nearby flex items-start gap-[12px] mb-[8px]"
                 [class.disabled]="isIssueLinked(issue.id)">
              <mat-checkbox
                [checked]="isIssueSelected(issue.id) || isIssueLinked(issue.id)"
                [disabled]="isIssueLinked(issue.id)"
                (change)="toggleIssueSelection(issue.id)"
                color="primary"
              ></mat-checkbox>
              <div class="issue-info flex-1">
                <div class="issue-title text-type-11">{{ issue.title }}</div>
                @if (issue.description) {
                  <div class="issue-description text-type-14 text-[#60698B] mt-[2px]">{{ issue.description }}</div>
                }
                <div class="issue-meta flex items-center gap-[8px] mt-[4px] flex-wrap">
                  <span class="issue-type-badge">{{ issue.type_label || issue.type || 'Issue' }}</span>
                  <span class="issue-status-badge">{{ issueStatusText(issue.status) }}</span>
                  <span class="issue-distance text-[#60698B]">{{ formatDistance(issue.distance) }}</span>
                </div>
                @if (issue.pictures?.length) {
                  <div class="issue-pictures flex gap-[6px] mt-[6px] flex-wrap">
                    @for (pic of issue.pictures; track pic.id) {
                      <img [src]="pic.thumb_url || pic.original_url" class="issue-thumbnail" alt="Issue photo" />
                    }
                  </div>
                }
                @if (isIssueLinked(issue.id)) {
                  <div class="already-linked-label text-[#60698B] mt-[2px]">Already linked to this item</div>
                }
              </div>
            </div>
          }
        }
      </div>
    }

    @if (mediaFiles?.length) {
      <app-pictures-section-with-tags
        (onDelete)="deletePicture($event)"
        [isEditable]="true"
        [pictures]="mediaFiles"
        class="pictures-section mb-[40px] mt-[30px]"
        label="Attachments"
      />
    }
  </div>

  <div class="action-section mb-[5px] flex flex-row gap-[20px] w-full">
    <div [matMenuTriggerFor]="add" class="action-button add-button">
      <mat-icon class="add" svgIcon="plus"></mat-icon>
    </div>
    <app-secondary-button (handleClick)="save(false)" [isDisabled]="saving || form.invalid || !fields" class="flex-1">Save</app-secondary-button>
    <app-primary-button (handleClick)="save(true)" [isDisabled]="saving || form.invalid || !fields" [isLoading]="saving" class="flex-1">Submit</app-primary-button>
  </div>
</div>

<input
  #fileInput
  (change)="onFileSelected($event)"
  class="hidden"
  multiple="multiple"
  type="file"
  accept="image/*,application/pdf,.pdf" />

<ng-template #mapLocation>
  @if (latitude !== null && longitude !== null) {
    <app-location-section
      (onDelete)="deleteLocation()"
      [isEditable]="true"
      [latitude]="latitude"
      [longitude]="longitude"
      [mapFeatureLink]="mapFeatureLink ?? null"
      class="mb-[20px]"
    />
  }
  @if (mapFeatureLink) {
    <app-design-context
      class="block mb-[20px]"
      data-testid="punchlist-item-design-context"
      [link]="mapFeatureLink"
      [collapseWhenCaptured]="true"
      [editable]="true"
      [projectId]="data?.projectId"
      (remove)="removeDesignContext()"
      (editLocation)="openLocationPicker()"
      (linkChange)="onDesignContextLinkChange($event)"
    />
  }
</ng-template>

<mat-menu #add="matMenu">
  @for (option of addMenuOptions; track option.key) {
    <button (click)="option.handler()" mat-menu-item>
      <div class="add-menu-item flex justify-start items-center">
        <div class="flex justify-center items-center h-[48px]">
          <mat-icon [svgIcon]="option.icon" class="menu-icon" />
        </div>
        <div class="menu-label">{{ option.label }}</div>
      </div>
    </button>
  }
</mat-menu>
